import { buildClassesHook } from '../../../helpers/styles';

export const useClasses = buildClassesHook({
    arrow: {
        fontSize: '2rem',
    },
});
